import React, { Component } from 'react';

class EthereumDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                Zequencer runs on the <a href="https://ethereum.org">Ethereum</a> blockchain.
                This means that metadata related to samples, projects, presets, and profiles
                is stored on the blockchain. The blockchain is immutable, which means that
                the metadata written to it cannot be altered or censored.
              </p>
             <p className="sub-header">
                Ether
              </p>
              <p>
                <b>Ether</b> is the main cryptocurrency used with Ethereum. Zequencer tokens are bought
                using <b>ether</b>. The transaction costs for writing to the blockchain are also paid using <b>ether</b>.
              </p>
              <p>
                Test <b>ether</b> is currently used with Zequencer, and costs no real money.
                When Zequencer switches to the <b>Main Ethereum Network</b>, the <b>ether</b> will
                cost real money.
                </p>
              <p>
                You can get test <b>ether</b> from <a href="https://faucet.metamask.io/">here</a>.
              </p>
              <p className="sub-header">
                Saving Projects
              </p>
              <p>
                To save a project publicly, you need to purchase <b>Zequencer tokens</b>.
                For now, this is free since Zequencer runs on the <b>Ropsten Test Network</b>. 
                Eventually, this will cost real money.
              <p>
                Saving projects privately costs no <b>Zequencer tokens</b>.
              </p>
              </p>
              <p className="sub-header">
                Buying Tokens
              </p>
              <p>
                When you save a song, it will tell you that you need to buy a token.
                So click “buy” and wait for the transaction to confirm.
                Once confirmed, you can then save. It will cost <b>1 Zequencer token</b> to save.
              </p>
              <p className="sub-header">
                Distribution of Tokens
              </p>
              <p>
                The token used to save a project gets distributed to each sample used
                in your track. The creators of the samples can then later retrieve the funds
                by proving that they own the samples. 
              </p>
              <p className="sub-header">
                Metamask
              </p>
              <p>
                Metamask is a browser plugin that connects websites, like Zequencer, to your Ethereum wallet.
              </p>
              <p>
                When Zequencer needs to save something to Ethereum on your behalf, a Metamask
                pop-up will appear asking you to confirm a transaction.
              </p>
              <p>
                Transactions in Ethereum cost a small fee (paid in <b>Ether</b>). The cost is proportional to how 
                large the transaction is.
              </p>
           </div>
        );
    }
}

export default EthereumDocumentation;
